import React from 'react';
import { MailQuestionIcon, TrendingDownIcon } from 'lucide-react';
import { NegativeCompLoan } from '../../types/commission';
import { formatPct, formatUsd } from '../../utils/format';
import { Badge } from '../sf/Badge';
import { Card } from '../sf/Card';
import { NewBadge } from '../sf/NewBadge';
import { OpenQuestionBadge } from '../sf/OpenQuestionBadge';
export function NegativeCompCard({
  loans
}: {
  loans: NegativeCompLoan[];
}) {
  return <Card title={`Negative comp loans (${loans.length})`} icon={TrendingDownIcon} iconBg="#FE9339" meta="Main uses ABS() on the comp %: the result is an amount, not floored at $0.00 and not capped." bodyClassName="" data-id="element-632" data-mp="m6a4gcdxe3t0">
      <p className="flex flex-wrap items-center gap-2 border-t border-sf-border px-4 py-2 text-xs text-sf-weak" data-id="element-633" data-mp="r30kx0tn71ey">
        <NewBadge label="NEW / requested" data-id="element-634" data-mp="2wx074wunnbty" />
        $0.00 adjusted display and flat $500 LO / $250 TL — pending decision, not applied.
      </p>
      <ul className="divide-y divide-sf-border border-t border-sf-border" data-id="element-635" data-mp="2swzv1iv13cq2">
        {loans.map(loan => <li key={loan.loanNumber} className="grid grid-cols-[minmax(0,1fr)_auto] gap-x-4 px-4 py-3" data-id="element-636" data-mp="34e8pot00h3lo">
            <div className="min-w-0" data-id="element-637" data-mp="39dlmo6kljr1z">
              <p className="flex flex-wrap items-center gap-2 text-[13px]" data-id="element-638" data-mp="39cjyd0ekl82b">
                <span className="font-semibold text-sf-blue" data-id="element-639" data-mp="3e4k1t2tumj3n">{loan.loanNumber}</span>
                <span className="text-sf-weak" data-id="element-640" data-mp="3j3ewb216hw3l">
                  · {loan.borrower} · {loan.loanOfficer} · {loan.branch}
                </span>
                <Badge tone="warning" data-id="element-641" data-mp="3n3femxreerfx">Negative comp</Badge>
              </p>
              <p className="mt-0.5 text-xs tabular-nums text-sf-weak" data-id="element-642" data-mp="3s3juclkhfi53">
                {formatUsd(loan.loanAmount)} × {formatPct(loan.totalCompPct)} = {formatUsd(loan.revenue)} − {formatUsd(loan.feeShort)} fee short (halved) ={' '}
                <span className="font-semibold text-sf-red" data-id="element-643" data-mp="1xrmxgd39tk2n">{formatUsd(loan.revenueAfterShort)}</span> → ABS ÷ {formatPct(loan.divisorPct)}
              </p>
              <p className="mt-1 flex flex-wrap items-center gap-1.5 text-xs text-sf-weak" data-id="element-644" data-mp="1unnu4t2kzrt8">
                <MailQuestionIcon className="h-3.5 w-3.5" aria-hidden="true" data-id="element-645" data-mp="1qn3xrrpu0s85" />
                Proposed alert · Recipients: to be confirmed (open question)
                <OpenQuestionBadge data-id="element-646" data-mp="24nodug4d49xy" />
              </p>
            </div>
            <div className="text-right" data-id="element-647" data-mp="1zmimomqcouqj">
              <p className="text-xs text-sf-weak" data-id="element-648" data-mp="1zpmz27dyywsa">Adjusted Loan Amount</p>
              <p className="font-semibold tabular-nums" data-id="element-649" data-mp="2dli87likgtih">{formatUsd(loan.adjustedAmount)}</p>
              <p className="text-[11px] text-sf-weak" data-id="element-650" data-mp="29kyfcu510c25">ABS, no floor</p>
            </div>
          </li>)}
      </ul>
    </Card>;
}